import "./Grid.scss";

import { PureComponent } from "react";
import { GridToolbar as KGridToolbar } from "@progress/kendo-react-grid";

import type { GridToolbarProps as KGridToolbarProps } from "@progress/kendo-react-grid";

export class GridToolbar extends PureComponent<KGridToolbarProps> {
  public static displayName = "KendoReactGridToolbar";

  render() {
    return <KGridToolbar {...this.props} />;
  }
}

export interface GridToolbarProps extends KGridToolbarProps {}
